// extracted by mini-css-extract-plugin
export var withLabels = "vcl-token-module--withLabels--15396";